/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentAssociatedCompanyViewModel } from "../types/IndividualPaymentAssociatedCompanyViewModel.ts";

export const individualPaymentAssociatedCompanyViewModelSchema = z.object({
  selectedAssociatedCompanyId: z.number().int().nullish(),
  companyName: z.string().nullish(),
  cnpj: z.string().nullish(),
  ie: z.string().nullish(),
  ieFree: z.optional(z.boolean()),
  companyContactName: z.string().nullish(),
  companyContactEmail: z.string().nullish(),
  companyContactPhone: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentAssociatedCompanyViewModel>;
